module.exports = __webpack_public_path__ + "static/img/1-new.8d3540df.png";